import moment from "moment";

import store from "../../../../store";

import Flowit from "../../../../services/flowit";
import * as types from "./types";
import { state } from "./mutations";

/* eslint-disable */
export const loadSummary = ({ commit }) => {
  Flowit.partners.summary().then(response => {
    commit(types.SET_SUMMARY, response.data.summary);
  });
};

export const load = ({ commit, state }, params) => {
  commit(types.LOADING_DATA, true);
  commit(types.LIST, []);
  Flowit.partners
    .list(state.filterParams)
    .then(response => {
      commit(types.LIST, response.data.affiliates);
      commit(types.LIMIT, response.data.limit);
      commit(types.PAGE, response.data.page);
      commit(types.SET_TOTAL_RESOURCES, response.data.resources);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      commit(types.ERRORS, error);
      commit(types.SHOW_ERROR, true);
      commit(types.LOADING_DATA, false);
    });
    Flowit.partners.categoriesList().then(response => {
      commit(types.LIST_CATEGORIES, response.data);
      commit(types.LOADING_DATA, false);
    });
};

export const get = ({ commit }, partnerId) => {
  commit(types.LOADING_DATA, true);
  Flowit.partners.get(partnerId).then(response => {
    commit(types.SET_PARTNER_DATA, response.data);
    commit(types.LOADING_DATA, false);
  });
};

export const getCep = ({ commit }, cep) => {
  commit(types.LOADING_DATA, true);
  Flowit.correios
    .getCep(cep)
    .then(response => {
      if(response.data.erro) {
        commit(types.SHOW_ERROR, true);
      } else{
        commit(types.SET_CEP_DATA, response.data);
        commit(types.SHOW_ERROR, false);
      }
      commit(types.LOADING_DATA, false);
    }).catch(err => {
      commit(types.SHOW_ERROR, true);
      commit(types.LOADING_DATA, false);
    });
}

export const createAccount = ({ commit }, params) => {
  commit(types.IS_LOAD, true);
  Flowit.partners
    .createAccount(params)
    .then(response => {
      commit(types.ACCOUNT, response.data);
      commit(types.SHOW_SUBMIT, false);
      commit(types.SHOW_SUCCESS, true);
      commit(types.IS_LOAD, false);
    })
    .catch(error => {
      commit(types.ERRORS, error.response.data);
      commit(types.SHOW_ERROR, true);
      commit(types.IS_LOAD, false);
    });
};

export const show = ({ commit }, params) => {
  commit(types.IS_LOAD, true);
  Flowit.recharges.show(params).then(
    response => {
      commit(types.RECHARGE, response.data.recharge);
      commit(types.SHOW_SUBMIT, false);
      if (response.data.recharge.status === "authorized") {
        commit(types.SHOW_CONFIRM, true);
        commit(types.SHOW_CANCEL, true);
        commit(types.LOADING_DATA, false);
      }
    },
    error => {
      // console.log("Error: " + response);
      commit(types.LOADING_DATA, false);
    }
  );
};

export const confirm = ({ commit }, params) => {
  commit(types.IS_LOAD, true);
  Flowit.recharges.confirm(params).then(
    response => {
      commit(types.RECHARGE, response.data.recharge);
      commit(types.SHOW_CONFIRM, false);
      commit(types.SHOW_CANCEL, false);
      if (response.data.recharge.status === "authorized") {
        commit(types.SHOW_CONFIRM, true);
        commit(types.SHOW_CANCEL, true);
        commit(types.IS_LOAD, false);
      }
    },
    error => {
      // console.log("Error: " + response);
      commit(types.IS_LOAD, false);
    }
  );
};

export const cancel = ({ commit }, params) => {
  commit(types.IS_LOAD, true);
  Flowit.recharges.cancel(params).then(
    response => {
      commit(types.RECHARGE, response.data.recharge);
      commit(types.SHOW_CONFIRM, false);
      commit(types.SHOW_CANCEL, false);
      if (response.data.recharge.status === "authorized") {
        commit(types.SHOW_CONFIRM, true);
        commit(types.SHOW_CANCEL, true);
        commit(types.IS_LOAD, false);
      }
    },
    error => {
      // console.log("Error: " + response);
      commit(types.IS_LOAD, false);
    }
  );
};

export const activeNew = ({ commit }, param) => {
  commit(types.ACTIVE_NEW, param);
};

export const toggleTaxForm = ({ commit }, param) => {
  commit(types.TOGGLE_TAX_FORM, param);
};

export const isLoad = ({ commit }, param) => {
  commit(types.IS_LOAD, param);
};

export const showAmount = ({ commit }, param) => {
  commit(types.SHOW_AMOUNT, param);
};

export const showNumber = ({ commit }, param) => {
  commit(types.SHOW_NUMBER, param);
};

export const showSubmit = ({ commit }, param) => {
  commit(types.SHOW_SUBMIT, param);
};

export const showConfirm = ({ commit }, param) => {
  commit(types.SHOW_CONFIRM, param);
};

export const showSuccess = ({ commit }, param) => {
  commit(types.SHOW_SUCCESS, param);
};

export const showError = ({ commit }, param) => {
  commit(types.SHOW_ERROR, param);
};

export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};

export const setAccountType = ({ commit }, model) => {
  commit(types.SET_FILTER_ACCOUNT_TYPE, model.business);
};

export const setPartner = ({ commit }, model) => {
  commit(types.SET_FILTER_PARTNER, model.business);
};

export const page = ({ commit }, param) => {
  commit(types.PAGE, param);
};

export const setTotalResources = ({ commit }, total) => {
  commit(types.SET_TOTAL_RESOURCES, total);
};

// FILTERS SETTINGS
export const resetFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_PARTNER_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_PARTNER_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_NAME, "");
  commit(types.SET_FILTER_PARTNER, "");
  commit(types.SET_FILTER_ORDINATION, "");
  state.filterParams.limit = 10;
  state.filterParams.page = 1;
  commit(types.LIMIT, 10);
  commit(types.PAGE, 1);
};

export const hideFilters = ({ commit }) => {
  commit(types.FILTER_STATUS, false);
};

export const loadFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("year")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("year")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_PARTNER_INITIAL_DATE, null);
  commit(types.SET_FILTER_PARTNER_FINAL_DATE, null);
  commit(types.LIMIT, 10);
  commit(types.PAGE, 1);
};

export const setInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_INITIAL_DATE, date);
};

export const setFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_FINAL_DATE, date);
};

export const setStartAt = ({ commit }, param) => {
  state.filterParams.filterrific.with_created_at_between.start_at = param;
};

export const setName = ({ commit }, model) => {
  commit(types.SET_FILTER_NAME, model.business);
};

export const setOrdination = ({ commit }, ordination) => {
  commit(types.SET_FILTER_ORDINATION, ordination.business);
};

export const setLimit = ({ commit }, param) => {
  commit(types.LIMIT, param);
  state.filterParams.limit = param;
};

export const setCurrentPage = ({ commit }, param) => {
  commit(types.PAGE, param);
  state.filterParams.page = param;
};

export const setLoadingData = ({ commit }, status) => {
  commit(types.LOADING_DATA, status);
};
